<template>
  <vue-modal :name="modalId" :width="modalWidth" height="auto" >
    <div id="preview-locale-modal" class="modal-content" style="overflow: auto;">
      <div class="modal-header">
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body" v-html="modalContent"></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary ml-4" @click="closeModal">Close</button>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import ViewMixins from "../mixins/ViewMixins.vue";

export default {
  name: "QuestionDescriptionModal",
  mixins: [ViewMixins],
  components: {},
  data() {
    return {
      modalReturnMessage: "",
    };
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    closeModal: function(){
      this.$modal.hide(this.modalId);
    },      
  },
  watch: {},
  props: {
    modalId: {
      type: String,
      default: "preview-locale",
    },
    modalTitle: {
      type: String,
      default: "",
    },
    modalContent: {
      type: String,
      default: "",
    },
    modalWidth: {
      type: Number,
      default: 368
    },
  }
};
</script>
